<template>
  <b-col class="m-auto text-center align-items-center">
    <img
      src="../../assets/login/mail_amarelo.svg"
      alt="Envelope com carta"
      class="w-50 mb-4"
    />

    <h2 class="text-tertiary">
      <span class="medium">{{ labels.text1 }}</span>
    </h2>
    <br />
    <h5 class="text-white" v-html="labels.text2"></h5>
  </b-col>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  computed: {
    ...mapGetters({
      resources: 'resources',
    }),
    labels() {
      return this.resources.page.login.inviteResend
    },
  },
}
</script>
